export var State;
(function (State) {
    State["ALABAMA"] = "Alabama";
    State["ALASKA"] = "Alaska";
    State["ARIZONA"] = "Arizona";
    State["ARKANSAS"] = "Arkansas";
    State["CALIFORNIA"] = "California";
    State["COLORADO"] = "Colorado";
    State["CONNECTICUT"] = "Connecticut";
    State["DELAWARE"] = "Delaware";
    State["DISTRICT_OF_COLUMBIA"] = "District of Columbia";
    State["FLORIDA"] = "Florida";
    State["GEORGIA"] = "Georgia";
    State["HAWAII"] = "Hawaii";
    State["IDAHO"] = "Idaho";
    State["ILLINOIS"] = "Illinois";
    State["INDIANA"] = "Indiana";
    State["IOWA"] = "Iowa";
    State["KANSAS"] = "Kansas";
    State["KENTUCKY"] = "Kentucky";
    State["LOUISIANA"] = "Louisiana";
    State["MAINE"] = "Maine";
    State["MARYLAND"] = "Maryland";
    State["MASSACHUSETTS"] = "Massachusetts";
    State["MICHIGAN"] = "Michigan";
    State["MINNESOTA"] = "Minnesota";
    State["MISSISSIPPI"] = "Mississippi";
    State["MISSOURI"] = "Missouri";
    State["MONTANA"] = "Montana";
    State["NEBRASKA"] = "Nebraska";
    State["NEVADA"] = "Nevada";
    State["NEW_HAMPSHIRE"] = "New Hampshire";
    State["NEW_JERSEY"] = "New Jersey";
    State["NEW_MEXICO"] = "New Mexico";
    State["NEW_YORK"] = "New York";
    State["NORTH_CAROLINA"] = "North Carolina";
    State["NORTH_DAKOTA"] = "North Dakota";
    State["OHIO"] = "Ohio";
    State["OKLAHOMA"] = "Oklahoma";
    State["OREGON"] = "Oregon";
    State["PENNSYLVANIA"] = "Pennsylvania";
    State["RHODE_ISLAND"] = "Rhode Island";
    State["SOUTH_CAROLINA"] = "South Carolina";
    State["SOUTH_DAKOTA"] = "South Dakota";
    State["TENNESSEE"] = "Tennessee";
    State["TEXAS"] = "Texas";
    State["UTAH"] = "Utah";
    State["VERMONT"] = "Vermont";
    State["VIRGINIA"] = "Virginia";
    State["WASHINGTON"] = "Washington";
    State["WEST_VIRGINIA"] = "West Virginia";
    State["WISCONSIN"] = "Wisconsin";
    State["WYOMING"] = "Wyoming";
})(State || (State = {}));
export var StateCode;
(function (StateCode) {
    StateCode["AL"] = "AL";
    StateCode["AK"] = "AK";
    StateCode["AZ"] = "AZ";
    StateCode["AR"] = "AR";
    StateCode["CA"] = "CA";
    StateCode["CO"] = "CO";
    StateCode["CT"] = "CT";
    StateCode["DE"] = "DE";
    StateCode["DC"] = "DC";
    StateCode["FL"] = "FL";
    StateCode["GA"] = "GA";
    StateCode["HI"] = "HI";
    StateCode["ID"] = "ID";
    StateCode["IL"] = "IL";
    StateCode["IN"] = "IN";
    StateCode["IA"] = "IA";
    StateCode["KS"] = "KS";
    StateCode["KY"] = "KY";
    StateCode["LA"] = "LA";
    StateCode["ME"] = "ME";
    StateCode["MD"] = "MD";
    StateCode["MA"] = "MA";
    StateCode["MI"] = "MI";
    StateCode["MN"] = "MN";
    StateCode["MS"] = "MS";
    StateCode["MO"] = "MO";
    StateCode["MT"] = "MT";
    StateCode["NE"] = "NE";
    StateCode["NV"] = "NV";
    StateCode["NH"] = "NH";
    StateCode["NJ"] = "NJ";
    StateCode["NM"] = "NM";
    StateCode["NY"] = "NY";
    StateCode["NC"] = "NC";
    StateCode["ND"] = "ND";
    StateCode["OH"] = "OH";
    StateCode["OK"] = "OK";
    StateCode["OR"] = "OR";
    StateCode["PA"] = "PA";
    StateCode["RI"] = "RI";
    StateCode["SC"] = "SC";
    StateCode["SD"] = "SD";
    StateCode["TN"] = "TN";
    StateCode["TX"] = "TX";
    StateCode["UT"] = "UT";
    StateCode["VT"] = "VT";
    StateCode["VA"] = "VA";
    StateCode["WA"] = "WA";
    StateCode["WV"] = "WV";
    StateCode["WI"] = "WI";
    StateCode["WY"] = "WY";
})(StateCode || (StateCode = {}));
/** State codes ordered alphabetically by full state name. */
export const STATE_CODES = [
    StateCode.AL,
    StateCode.AK,
    StateCode.AZ,
    StateCode.AR,
    StateCode.CA,
    StateCode.CO,
    StateCode.CT,
    StateCode.DE,
    StateCode.DC,
    StateCode.FL,
    StateCode.GA,
    StateCode.HI,
    StateCode.ID,
    StateCode.IL,
    StateCode.IN,
    StateCode.IA,
    StateCode.KS,
    StateCode.KY,
    StateCode.LA,
    StateCode.ME,
    StateCode.MD,
    StateCode.MA,
    StateCode.MI,
    StateCode.MN,
    StateCode.MS,
    StateCode.MO,
    StateCode.MT,
    StateCode.NE,
    StateCode.NV,
    StateCode.NH,
    StateCode.NJ,
    StateCode.NM,
    StateCode.NY,
    StateCode.NC,
    StateCode.ND,
    StateCode.OH,
    StateCode.OK,
    StateCode.OR,
    StateCode.PA,
    StateCode.RI,
    StateCode.SC,
    StateCode.SD,
    StateCode.TN,
    StateCode.TX,
    StateCode.UT,
    StateCode.VT,
    StateCode.VA,
    StateCode.WA,
    StateCode.WV,
    StateCode.WI,
    StateCode.WY,
];
export const STATE_OPTIONS_BY_CODE = {
    [StateCode.AL]: {
        name: State.ALABAMA,
        code: StateCode.AL,
    },
    [StateCode.AK]: {
        name: State.ALASKA,
        code: StateCode.AK,
    },
    [StateCode.AZ]: {
        name: State.ARIZONA,
        code: StateCode.AZ,
    },
    [StateCode.AR]: {
        name: State.ARKANSAS,
        code: StateCode.AR,
    },
    [StateCode.CA]: {
        name: State.CALIFORNIA,
        code: StateCode.CA,
    },
    [StateCode.CO]: {
        name: State.COLORADO,
        code: StateCode.CO,
    },
    [StateCode.CT]: {
        name: State.CONNECTICUT,
        code: StateCode.CT,
    },
    [StateCode.DE]: {
        name: State.DELAWARE,
        code: StateCode.DE,
    },
    [StateCode.DC]: {
        name: State.DISTRICT_OF_COLUMBIA,
        code: StateCode.DC,
    },
    [StateCode.FL]: {
        name: State.FLORIDA,
        code: StateCode.FL,
    },
    [StateCode.GA]: {
        name: State.GEORGIA,
        code: StateCode.GA,
    },
    [StateCode.HI]: {
        name: State.HAWAII,
        code: StateCode.HI,
    },
    [StateCode.ID]: {
        name: State.IDAHO,
        code: StateCode.ID,
    },
    [StateCode.IL]: {
        name: State.ILLINOIS,
        code: StateCode.IL,
    },
    [StateCode.IN]: {
        name: State.INDIANA,
        code: StateCode.IN,
    },
    [StateCode.IA]: {
        name: State.IOWA,
        code: StateCode.IA,
    },
    [StateCode.KS]: {
        name: State.KANSAS,
        code: StateCode.KS,
    },
    [StateCode.KY]: {
        name: State.KENTUCKY,
        code: StateCode.KY,
    },
    [StateCode.LA]: {
        name: State.LOUISIANA,
        code: StateCode.LA,
    },
    [StateCode.ME]: {
        name: State.MAINE,
        code: StateCode.ME,
    },
    [StateCode.MD]: {
        name: State.MARYLAND,
        code: StateCode.MD,
    },
    [StateCode.MA]: {
        name: State.MASSACHUSETTS,
        code: StateCode.MA,
    },
    [StateCode.MI]: {
        name: State.MICHIGAN,
        code: StateCode.MI,
    },
    [StateCode.MN]: {
        name: State.MINNESOTA,
        code: StateCode.MN,
    },
    [StateCode.MS]: {
        name: State.MISSISSIPPI,
        code: StateCode.MS,
    },
    [StateCode.MO]: {
        name: State.MISSOURI,
        code: StateCode.MO,
    },
    [StateCode.MT]: {
        name: State.MONTANA,
        code: StateCode.MT,
    },
    [StateCode.NE]: {
        name: State.NEBRASKA,
        code: StateCode.NE,
    },
    [StateCode.NV]: {
        name: State.NEVADA,
        code: StateCode.NV,
    },
    [StateCode.NH]: {
        name: State.NEW_HAMPSHIRE,
        code: StateCode.NH,
    },
    [StateCode.NJ]: {
        name: State.NEW_JERSEY,
        code: StateCode.NJ,
    },
    [StateCode.NM]: {
        name: State.NEW_MEXICO,
        code: StateCode.NM,
    },
    [StateCode.NY]: {
        name: State.NEW_YORK,
        code: StateCode.NY,
    },
    [StateCode.NC]: {
        name: State.NORTH_CAROLINA,
        code: StateCode.NC,
    },
    [StateCode.ND]: {
        name: State.NORTH_DAKOTA,
        code: StateCode.ND,
    },
    [StateCode.OH]: {
        name: State.OHIO,
        code: StateCode.OH,
    },
    [StateCode.OK]: {
        name: State.OKLAHOMA,
        code: StateCode.OK,
    },
    [StateCode.OR]: {
        name: State.OREGON,
        code: StateCode.OR,
    },
    [StateCode.PA]: {
        name: State.PENNSYLVANIA,
        code: StateCode.PA,
    },
    [StateCode.RI]: {
        name: State.RHODE_ISLAND,
        code: StateCode.RI,
    },
    [StateCode.SC]: {
        name: State.SOUTH_CAROLINA,
        code: StateCode.SC,
    },
    [StateCode.SD]: {
        name: State.SOUTH_DAKOTA,
        code: StateCode.SD,
    },
    [StateCode.TN]: {
        name: State.TENNESSEE,
        code: StateCode.TN,
    },
    [StateCode.TX]: {
        name: State.TEXAS,
        code: StateCode.TX,
    },
    [StateCode.UT]: {
        name: State.UTAH,
        code: StateCode.UT,
    },
    [StateCode.VT]: {
        name: State.VERMONT,
        code: StateCode.VT,
    },
    [StateCode.VA]: {
        name: State.VIRGINIA,
        code: StateCode.VA,
    },
    [StateCode.WA]: {
        name: State.WASHINGTON,
        code: StateCode.WA,
    },
    [StateCode.WV]: {
        name: State.WEST_VIRGINIA,
        code: StateCode.WV,
    },
    [StateCode.WI]: {
        name: State.WISCONSIN,
        code: StateCode.WI,
    },
    [StateCode.WY]: {
        name: State.WYOMING,
        code: StateCode.WY,
    },
};
/**
 * State options mapped by state codes array to guarantee alphabetical order.
 */
export const STATE_OPTIONS = STATE_CODES.map((code) => STATE_OPTIONS_BY_CODE[code]);
export var Territory;
(function (Territory) {
    Territory["AMERICAN_SAMOA"] = "American Samoa";
    Territory["GUAM"] = "Guam";
    Territory["NORTHERN_MARIANA_ISLANDS"] = "Northern Mariana Islands";
    Territory["PUERTO_RICO"] = "Puerto Rico";
    Territory["VIRGIN_ISLANDS"] = "Virgin Islands";
})(Territory || (Territory = {}));
export var TerritoryCode;
(function (TerritoryCode) {
    /** American Samoa */
    TerritoryCode["AS"] = "AS";
    /** Guam */
    TerritoryCode["GU"] = "GU";
    /** Northern Mariana Islands */
    TerritoryCode["MP"] = "MP";
    /** Puerto Rico */
    TerritoryCode["PR"] = "PR";
    /** Virgin Islands */
    TerritoryCode["VI"] = "VI";
})(TerritoryCode || (TerritoryCode = {}));
/** Territory codes ordered alphabetically by full territory name. */
export const TERRITORY_CODES = [
    TerritoryCode.AS,
    TerritoryCode.GU,
    TerritoryCode.MP,
    TerritoryCode.PR,
    TerritoryCode.VI,
];
export const TERRITORY_OPTIONS_BY_CODE = {
    [TerritoryCode.AS]: {
        name: Territory.AMERICAN_SAMOA,
        code: TerritoryCode.AS,
    },
    [TerritoryCode.GU]: {
        name: Territory.GUAM,
        code: TerritoryCode.GU,
    },
    [TerritoryCode.MP]: {
        name: Territory.NORTHERN_MARIANA_ISLANDS,
        code: TerritoryCode.MP,
    },
    [TerritoryCode.PR]: {
        name: Territory.PUERTO_RICO,
        code: TerritoryCode.PR,
    },
    [TerritoryCode.VI]: {
        name: Territory.VIRGIN_ISLANDS,
        code: TerritoryCode.VI,
    },
};
/**
 * Territory options mapped by territory codes array to guarantee alphabetical
 * order.
 */
export const TERRITORY_OPTIONS = TERRITORY_CODES.map((code) => TERRITORY_OPTIONS_BY_CODE[code]);
export const STATE_AND_TERRITORY_OPTIONS_BY_CODE = Object.assign(Object.assign({}, STATE_OPTIONS_BY_CODE), TERRITORY_OPTIONS_BY_CODE);
//# sourceMappingURL=states.js.map